import { useUser } from '@poplar/hooks/useUser';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
var COUNTRY_TO_DEFAULT_CURRENCY = {
  US: 'USD',
  JP: 'JPY'
};
export var usePreferredCurrency = function usePreferredCurrency(currencyCode) {
  var _profile$localeSettin;

  var _useUser = useUser(),
      profile = _useUser.profile;

  var _useIntlMeta = useIntlMeta(),
      country = _useIntlMeta.country;

  if (currencyCode) {
    return currencyCode;
  }

  if (profile !== null && profile !== void 0 && (_profile$localeSettin = profile.localeSettings) !== null && _profile$localeSettin !== void 0 && _profile$localeSettin.currencyCode) {
    var _profile$localeSettin2;

    return profile === null || profile === void 0 ? void 0 : (_profile$localeSettin2 = profile.localeSettings) === null || _profile$localeSettin2 === void 0 ? void 0 : _profile$localeSettin2.currencyCode;
  }

  if (country in COUNTRY_TO_DEFAULT_CURRENCY) {
    return COUNTRY_TO_DEFAULT_CURRENCY[country];
  }

  throw new Error('Unable to determine preferred currency code');
};